// 에이전트 표시명 정제 (Figma ver.7 "결과 카드 실데이터 규칙": 제품명 안 URL · 괄호 설명은 표시명에서 제외).
// 이름 끝에 공백으로 떨어져 붙은 괄호가 URL이거나 한글 설명일 때만 떼요:
//   "RUNE (https://rune.team)" → "RUNE", "Moss Dynamic Visual Guidance (실시간 화면 안내 에이전트)" → "Moss Dynamic Visual Guidance"
// 시안이 그대로 둔 이름은 건드리지 않아요: "STAR(주행소프트웨어), STARGRAPHER(…)"(공백 없이 붙은 괄호), "I'st JAI 제조 LLM (Cloud / On-Premise)"(영문 괄호).
// 전체 이름은 호출하는 쪽이 마우스 오버 툴팁(title)으로 보여 줘요. 등록 시 표시명 필드를 따로 두는 건 데이터 담당 확인 사항이에요.
const TRAILING_NOTE = /\s+\(([^()]*)\)\s*$/;
const URL_LIKE = /(https?:\/\/|www\.)/i;
const HANGUL = /[가-힣]/;

export function agentDisplayName(name: string): string {
  const match = TRAILING_NOTE.exec(name);
  if (!match) return name;
  const note = match[1];
  if (!URL_LIKE.test(note) && !HANGUL.test(note)) return name;
  const cleaned = name.slice(0, match.index).trim();
  return cleaned || name;
}
